import {environment} from '@env/environment';

const baseUrl: string = environment.endpointApi;

export const getBaseUrl = (idEmpresa, modeRoot): string => {
    return modeRoot ? `${baseUrl}/root/companies/${idEmpresa}` : baseUrl;
};
